<template>
  <div v-if="offerId" class="flex items-center md:order-last">
    <div
      class="bg-static-info-mid border-static-default-low rounded-lg flex items-center border p-8"
    >
      <IconSim />
    </div>
    <RevLink
      class="ml-12 text-left"
      @click="openModal('mobile-plan-assistance', $event)"
    >
      {{ i18n(translations.mobilePlanAssistance, { partnerLabel }) }}
    </RevLink>

    <MobilePlanAssistanceDrawer
      name="mobile-plan-assistance"
      :offer-id
      :partner-label
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconSim } from '@ds/icons/IconSim'

import MobilePlanAssistanceDrawer from '../MobilePlanAssistanceDrawer/MobilePlanAssistanceDrawer.vue'

import translations from './MobilePlanReassuranceItems.translations'

const i18n = useI18n()

defineProps<{
  offerId?: string
  partnerLabel: string
}>()
</script>
